import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { BdcPropertySummaryDialogComponent } from './bdc-property-summary-dialog/bdc-property-summary-dialog.component'
import { BdcCreatePropertyDialogComponent } from './bdc-create-property-dialog/bdc-create-property-dialog.component'
import { BdcCreatePropertyEntityIdComponent } from './bdc-create-property-dialog/bdc-create-property-entity-id/bdc-create-property-entity-id.component'
import { BdcCreatePropertyCompleteComponent } from './bdc-create-property-dialog/bdc-create-property-complete/bdc-create-property-complete.component'
import { BdcCreatePropertyDetailsComponent } from './bdc-create-property-dialog/bdc-create-property-details/bdc-create-property-details.component'
import { BdcCreatePropertyDialogService } from './bdc-create-property-dialog/bdc-create-property-dialog.service'
import { BdcPropertyDetailDialogComponent } from './bdc-property-detail-dialog/bdc-property-detail-dialog.component'
import { BdcPropertyDetailsComponent } from './bdc-property-detail-dialog/bdc-property-details/bdc-property-details.component'
import { BdcPropertyUnitsComponent } from './bdc-property-detail-dialog/bdc-property-units/bdc-property-units.component'
import { BdcPropertyAmenitiesComponent } from './bdc-property-detail-dialog/bdc-property-amenities/bdc-property-amenities.component'
import { BdcPropertyContactsComponent } from './bdc-property-detail-dialog/bdc-property-contacts/bdc-property-contacts.component'
import { BdcPropertyLicensesComponent } from './bdc-property-detail-dialog/bdc-property-licenses/bdc-property-licenses.component'
import { BdcPropertyPhotosComponent } from './bdc-property-detail-dialog/bdc-property-photos/bdc-property-photos.component'
import { BdcPropertyProductsComponent } from './bdc-property-detail-dialog/bdc-property-products/bdc-property-products.component'
import { BdcPropertyDetailDialogService } from './bdc-property-detail-dialog/bdc-property-detail-dialog.service'
import { BdcPropertySettingsComponent } from './bdc-property-detail-dialog/bdc-property-settings/bdc-property-settings.component'
import { BdcPropertyRatesComponent } from './bdc-property-detail-dialog/bdc-property-rates/bdc-property-rates.component'
import { BdcCreatePropertyContactDialogComponent } from './bdc-create-property-contact-dialog/bdc-create-property-contact-dialog.component'
import { BdcCreatePropertyContactDialogService } from './bdc-create-property-contact-dialog/bdc-create-property-contact-dialog.service'
import { BdcPropertyProductDialogService } from './bdc-property-product-dialog/bdc-property-product-dialog.service'
import { BdcPropertyProductDialogComponent } from './bdc-property-product-dialog/bdc-property-product-dialog.component'
import { BdcPropertyUnitDialogService } from './bdc-property-unit-dialog/bdc-property-unit-dialog.service'
import { BdcPropertyUnitDialogComponent } from './bdc-property-unit-dialog/bdc-property-unit-dialog.component'
import { BdcPropertyPhotosGalleryComponent } from './bdc-property-detail-dialog/bdc-property-photos-gallery/bdc-property-photos-gallery.component'
import { BdcCreatePropertyAddressComponent } from './bdc-create-property-dialog/bdc-create-property-address/bdc-create-property-address.component'

import { PhotoCardComponent } from './bdc-property-detail-dialog/shared/photo-card/photo-card.component'
import { PhotoGridComponent } from './bdc-property-detail-dialog/shared/photo-grid/photo-grid.component'
import { BdcPropertyUnitDetailsComponent } from './bdc-property-unit-dialog/bdc-property-unit-details/bdc-property-unit-details.component'
import { BdcPropertyUnitLicenseComponent } from './bdc-property-unit-dialog/bdc-property-unit-license/bdc-property-unit-license.component'
import { BdcPropertyUnitGalleryComponent } from './bdc-property-unit-dialog/bdc-property-unit-gallery/bdc-property-unit-gallery.component'
import { BdcPropertyUnitAmenitiesComponent } from './bdc-property-unit-dialog/bdc-property-unit-amenities/bdc-property-unit-amenities.component'
import { BdcPropertyUnitBathroomComponent } from './bdc-property-unit-dialog/bdc-property-unit-bathroom/bdc-property-unit-bathroom.component'
import { BdcLicensesFormComponent } from './bdc-licenses-form/bdc-licenses-form.component'
import { DragulaModule } from 'ng2-dragula'
import { ChannelContentLibraryModule } from '@tokeet-frontend/channel-content'

const components = [
  BdcCreatePropertyDialogComponent,
  BdcCreatePropertyEntityIdComponent,
  BdcCreatePropertyDetailsComponent,
  BdcCreatePropertyAddressComponent,
  BdcCreatePropertyCompleteComponent,

  //
  BdcLicensesFormComponent,
  //
  BdcPropertyAmenitiesComponent,
  BdcPropertyContactsComponent,
  BdcPropertyLicensesComponent,
  BdcPropertyPhotosComponent,
  BdcPropertyProductsComponent,
  BdcPropertyUnitsComponent,
  BdcPropertySettingsComponent,
  BdcPropertyRatesComponent,
  BdcPropertyDetailsComponent,
  BdcPropertyDetailDialogComponent,
  BdcCreatePropertyContactDialogComponent,
  //
  BdcPropertyUnitDetailsComponent,
  BdcPropertyUnitLicenseComponent,
  BdcPropertyUnitGalleryComponent,
  BdcPropertyUnitAmenitiesComponent,
  BdcPropertyUnitBathroomComponent,
  BdcPropertyUnitDialogComponent,
  //
  BdcPropertyProductDialogComponent,
  BdcPropertySummaryDialogComponent,
  BdcPropertyPhotosGalleryComponent,
  PhotoCardComponent,
  PhotoGridComponent,
]

const services = [
  //
  BdcPropertyUnitDialogService,
  BdcPropertyProductDialogService,
  BdcCreatePropertyDialogService,
  BdcCreatePropertyContactDialogService,
  BdcPropertyDetailDialogService,
]

@NgModule({
  imports: [SharedModule, CommonModule, DragulaModule, ChannelContentLibraryModule],
  declarations: [...components],
  exports: [...components],
  providers: [...services],
})
export class BdcContentModule {}
